export default "__VITE_ASSET__BECy29HS__"